import React from "react";
import showdown from 'showdown';
import styled, { css } from "react-emotion";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const converter = new showdown.Converter();

const Image = styled("img")`
  width: 250px;
  margin-bottom: 1rem;
  margin-right: 1rem;
  cursor: pointer;
`;

const Headline = styled("h3")`
  font-weight: 100;
`;

export default class OutdoorProperty extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
    }

    this.images = [this.props.image, this.props.image2, this.props.image3];
  }

  render() {

    return (
      <div>
        <Headline>{this.props.headline}</Headline>
        {this.props.image && 
        <Image src={this.props.image} alt={this.props.imagealt} onClick={() => this.setState({ isOpen: true })}/>
        }
        {this.props.image2 && 
        <Image src={this.props.image2} alt={this.props.imagealt2} onClick={() => this.setState({ isOpen: true })}/>
        }
        {this.props.image3 && 
        <Image src={this.props.image3} alt={this.props.imagealt3} onClick={() => this.setState({ isOpen: true })}/>
        }
        <ul>
          {this.props.properties.map(prop => (
            <li>{prop.property}</li>
          ))}
        </ul>
        <div dangerouslySetInnerHTML={{ __html: converter.makeHtml(this.props.description) }} />
        {this.state.isOpen && (
          <Lightbox
          mainSrc={this.images[this.state.photoIndex]}
          nextSrc={this.images[(this.state.photoIndex + 1) % this.images.length]}
          prevSrc={this.images[(this.state.photoIndex + this.images.length - 1) % this.images.length]}
          onCloseRequest={() => this.setState({ isOpen: false })}
          onMovePrevRequest={() =>
            this.setState({
              photoIndex: (this.state.photoIndex + this.images.length - 1) % this.images.length,
            })
          }
          onMoveNextRequest={() =>
            this.setState({
              photoIndex: (this.state.photoIndex + 1) % this.images.length,
            })
          }
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/outdoorProperties.js